import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Header } from './Header';
import { Intro } from './Intro';
import { config } from './../../config/config';
const { colorConfig } = config();

const CalculatorsGroup = styled.div`
  padding: 20px;
  display: flex;

  a.link {
    border: 1px ${colorConfig.main} solid;
    cursor: pointer;
    flex: 1;
    display: block;
    text-align: center;
    text-decoration: none;
    border-bottom: 8px ${colorConfig.main} solid;
    padding-top: 20px;
    padding-bottom: 40px;
    position: relative;
  }
  a.link .card {
    background-color: ${colorConfig.main};
    padding: .6rem;
    color: white;
    position: absolute;
    left: 0px;
    right: 0px;
    visibility: hidden;
    font-size: 22px; font-family: 'Nunito Sans',arial; font-weight: 400;
    text-align: center;
  }
  a.link:hover { padding-bottom: 0px; }
  a.link:hover .card { visibility: visible; transition: bottom 3s; }
  a.link img { height: 120px; }

  a.link.disabled { border-color: #888; }
  a.link.disabled div { color: #888 !important; }
  a.link.disabled .card { border-color: #888; background-color: #888; color: white !important; }


  @media(max-width: 860px) {
    display: block;
    a.link { margin-bottom: 50px; padding-bottom: 0px; }
    a.link .card { visibility: visible; }
  }

`;
const CalculatorTitle = styled.div`
  text-align: center;
  color: ${colorConfig.main};
  line-height: 1.5em;
  font-size: 22px;
  font-family: 'Nunito+Sans', aria';
  @media(max-width: 1024px) {
    font-size: 18px;
  }
  margin-top: 20px;
  margin-bottom: 20px;
`;

const titleIntro = [
  'At more 2 life we have the some of the most modern and flexible product features in the market.',
  'Use the calculators to produce scenarios on how each features could work for your clients.'
];
export const IndexComponent = ({ screen }) => {
  return (
    <div>
      <Header {...screen} />
      {screen.inFrame ? false : <Intro title={titleIntro} />}
      <CalculatorsGroup>

        <Link className="link" to="/partial-repayment">
          <img src="images/calc1.png?v=1" alt="Impact of partial repayments calculator" />
          <CalculatorTitle>Impact of partial<br />repayments calculator</CalculatorTitle>
          <div className="card">Calculate</div>
        </Link>

        <Link className="link" to="/guaranteed-inheritance">
          <img src="images/calc2.png?v=1" alt="Guarantee inheritance feature calculator" />
          <CalculatorTitle>Inheritance<br/>protection tool</CalculatorTitle>
          <div className="card">Calculate</div>
        </Link>

        <Link className="link" to="/ltv-calculator">
          <img src="images/calc3.png?v=1" alt="Tailored Choice enhanced LTV calculator" />
          <CalculatorTitle>Tailored Choice <br />Loan-to-value calculator</CalculatorTitle>
          <div className="card">Calculate</div>
        </Link>
      </CalculatorsGroup>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Calculators/IndexComponent.js